module.exports = __webpack_public_path__ + "static/media/home-bg-9.75038e67.jpg";